import React, {useRef} from "react";

// simplebar
import SimpleBar from "simplebar-react";
// import "simplebar/dist/simplebar.min.css";

interface AppSimpleBarProps {
  children: any;
  style?: object;
  className?: string;
  scrollRef?: any;
  onScrollCapture?: (event: any) => void;
}
const AppSimpleBar = ({
  children,
  style,
  className,
  scrollRef,
  onScrollCapture,
}: AppSimpleBarProps) => {
  // const renderCount = useRef(0);
  // renderCount.current++;
  // console.log("AppSimpleBar Render = " + renderCount.current);

  const onSimpleBarScroll = (event: any) => {
    //console.log('onSimpleBarScroll');
  }
  return (
    <SimpleBar style={style} className={className} ref={scrollRef} onScrollCapture={onScrollCapture} >
      {children}
    </SimpleBar>
  );
};

// export default AppSimpleBar;
export default React.memo(AppSimpleBar);